import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";
import Desplegable from "../../desplegable";
import * as utils from "../../../utils.js";

export default class VistaDatosPersonales extends Component {
  render() {
    const CarnetConducir =
      this.props.DatosUsuario.drivingLicense && this.props.DatosUsuario.drivingLicense !== "" ? (
        <Col lg="6" className="border">
          <h6>Carnet de Conducir</h6>
          <a href={process.env.REACT_APP_API_URL + "/download/usuarios/" + this.props.DatosUsuario.id + "/carnetConducir"} target="_blank" rel="noreferrer">
            Ver Carnet de Conducir
          </a>
        </Col>
      ) : (
        <Col lg="6" className="border">
          <h6>Carnet de Conducir</h6>
          <p>No se encuentra el documento</p>
        </Col>
      );
    const pasaporte =
      this.props.DatosUsuario.passportDocument && this.props.DatosUsuario.passportDocument !== "" ? (
        <Col lg="6" className="border">
          <Row>
            <Col>
              <h6>Archivo Pasaporte <small>(máx. 500KB)</small></h6>
              <a href={process.env.REACT_APP_API_URL + "/download/usuarios/" + this.props.DatosUsuario.id + "/pasaporte"} target="_blank" rel="noreferrer">
                Ver Pasaporte
              </a>
            </Col>
          </Row>
        </Col>
      ) : (
        <Col lg="6" className="border">
          <h6>Archivo Pasaporte <small>(máx. 500KB)</small></h6>
          <p>No se encuentra el documento</p>
        </Col>
      );

    const cv =
      (this.props.DatosUsuario.cv === null || this.props.DatosUsuario.cv) && this.props.DatosUsuario.type === "Laico" ? (
        this.props.DatosUsuario.cv !== null ? (
          <Col lg="6" className="border">
            <h6>Curriculum</h6>
            <a href={process.env.REACT_APP_API_URL + "/download/usuarios/" + this.props.DatosUsuario.id + "/cv"} target="_blank" rel="noreferrer">
              Curriculum
            </a>
          </Col>
        ) : (
          <Col lg="6" className="border">
            <h6>Curriculum </h6>
            <p>No se encuentra el documento</p>
          </Col>
        )
      ) : null;

    const DesplegablePasaporte = this.props.DatosUsuario.passport ? (
      <Desplegable
        Toogle={"Datos Pasaporte"}
        Text={
          <Col>
            <Row>
              <Col lg="6" className="border">
                <h6>Número de pasaporte</h6>
                <p>{this.props.DatosUsuario.passport}</p>
              </Col>
              <Col lg="6" className="border">
                <h6>Emitido por</h6>
                <p>{this.props.DatosUsuario.passportIssued}</p>
              </Col>
            </Row>
            <Row>
              <Col lg="6" className="border">
                <h6>Fecha Emisión</h6>
                <p>{utils.formatDate(this.props.DatosUsuario.issuedDate)}</p>
              </Col>
              <Col lg="6" className="border">
                <h6>Fecha Expiración</h6>
                <p>{utils.formatDate(this.props.DatosUsuario.expiryDate)}</p>
              </Col>
            </Row>
            <Row>
              <Col lg="6" className="border">
                <h6>Lugar de emisión</h6>
                <p>{this.props.DatosUsuario.passportPlace}</p>
              </Col>

              {pasaporte}
            </Row>
          </Col>
        }
      />
    ) : null;

    let genero = this.props.DatosUsuario.gender && this.props.DatosUsuario.gender === "h" ? "Hombre" : "Mujer";

    let vistaGenero =
      this.props.DatosUsuario.type === "Laico" ? (
        <Col lg="3" className="border">
          <h6>Género</h6>
          <p>{genero}</p>
        </Col>
      ) : null;

    return (
      <React.Fragment>
        <Container className="mb-3">
          <Row>
            <Col lg="3" className="border">
              <h6>Nombre</h6>
              <p>{this.props.DatosUsuario.name}</p>
            </Col>
            <Col lg="3" className="border">
              <h6>Primer Apellido</h6>
              <p>{this.props.DatosUsuario.firstSurname}</p>
            </Col>
            <Col lg="3" className="border">
              <h6>Segundo Apellido</h6>
              <p>{this.props.DatosUsuario.secondSurname}</p>
            </Col>
            <Col lg="3" className="border">
              <h6>Teléfono</h6>
              <p>{this.props.DatosUsuario.telephone}</p>
            </Col>
          </Row>
          <Row>
            <Col lg="3" className="border">
              <h6>País de Nacimiento</h6>
              <p>{this.props.DatosUsuario.birthCountry}</p>
            </Col>
            <Col lg="3" className="border">
              <h6>Provincia de Nacimiento</h6>
              <p>{this.props.DatosUsuario.birthProvince}</p>
            </Col>
            <Col lg="3" className="border">
              <h6>Ciudad o localidad de Nacimiento</h6>
              <p>{this.props.DatosUsuario.birthAddress}</p>
            </Col>
            <Col lg="3" className="border">
              <h6>Fecha de Nacimiento</h6>
              <p>{utils.formatDate(this.props.DatosUsuario.birthdate)}</p>
            </Col>
          </Row>
          <Row>
            <Col lg="3" className="border">
              <h6>Nacionalidad</h6>
              <p>{this.props.DatosUsuario.nationality}</p>
            </Col>
            <Col lg="3" className="border">
              <h6>Tipo de Identidad</h6>
              <p>{this.props.DatosUsuario.documentType}</p>
            </Col>
            <Col lg="3" className="border">
              <h6>Número de Identidad</h6>
              <p>{this.props.DatosUsuario.documentId}</p>
            </Col>
            {vistaGenero}
          </Row>
          <Row>
            {CarnetConducir}
            <Col lg="6" className="border">
              <h6>Email</h6>
              <p>{this.props.DatosUsuario.email}</p>
            </Col>
          </Row>
          <Row>{cv}</Row>
        </Container>
        {DesplegablePasaporte}
      </React.Fragment>
    );
  }
}
